export default __webpack_public_path__ + "static/char-v-54-74ff369e0bbe6c7b42370ff81e8eca66.webp";